import React, { Component } from "react";
import VisibilitySensor from "react-visibility-sensor";
import { CircularProgressbar, buildStyles } from "react-circular-progressbar/";
import "react-circular-progressbar/dist/styles.css";
import Reveal from "react-reveal";
import Cta from "./Banner/Cta";

class Cprogress extends Component {
  render() {
    return (
      <section className="progress_bar_area">
        <div className="container">
          <div className="sec_title mb_70 wow fadeInUp" data-wow-delay="0.4s">
            <h2 className="f_p f_size_30 l_height40 f_600 t_color text-center">
              Vous n'êtes pas <br /> seul
            </h2>
          </div>
          <Reveal bottom cascade duration={1200}>
            <div className="row">
              <div className="col-lg-4 col-md-4 progress_item">
                <VisibilitySensor partialVisibility>
                  {({ isVisible }) => {
                    const percentage = isVisible ? 95 : 0;
                    return (
                      <CircularProgressbar
                        value={percentage}
                        text={`${percentage}%`}
                        strokeWidth={5}
                        styles={buildStyles({
                          rotation: 0,
                          textSize: "20px",
                          pathTransitionDuration: 1,
                          pathColor: "#aa6ffa",
                          textColor: "#051441",
                          trailColor: "#f1f1fa",
                        })}
                      />
                    );
                  }}
                </VisibilitySensor>
                <h4>sont soulagés d’avoir contrôlé leur audition</h4>
                <p></p>
              </div>
              <div className="col-lg-4 col-md-4 progress_item">
                <VisibilitySensor>
                  {({ isVisible }) => {
                    const percentage = isVisible ? 47 : 0;
                    return (
                      <CircularProgressbar
                        value={percentage}
                        text={`${percentage}%`}
                        strokeWidth={5}
                        styles={buildStyles({
                          rotation: 0,
                          textSize: "20px",
                          pathTransitionDuration: 1,
                          pathColor: "#fa6fd1",
                          textColor: "#051441",
                          trailColor: "#f1f1fa",
                        })}
                      />
                    );
                  }}
                </VisibilitySensor>
                <h4>ont une déficience auditive légère ou grave</h4>
                <p></p>
              </div>
              <div className="col-lg-4 col-md-4 progress_item">
                <VisibilitySensor>
                  {({ isVisible }) => {
                    const percentage = isVisible ? 12 : 0;
                    return (
                      <CircularProgressbar
                        value={percentage}
                        text={`${percentage}%`}
                        strokeWidth={5}
                        styles={buildStyles({
                          rotation: 0,
                          textSize: "20px",
                          pathTransitionDuration: 1,
                          pathColor: "#f3af4e",
                          textColor: "#051441",
                          trailColor: "#f1f1fa",
                        })}
                      />
                    );
                  }}
                </VisibilitySensor>
                <h4>ont pris un rendez-vous chez un audioprothésiste</h4>
                <p></p>
              </div>
            </div>
            <Cta text="Découvrez votre résultat" />
          </Reveal>
          <div className="br_bottom"></div>
        </div>
      </section>
    );
  }
}
export default Cprogress;
